"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localTimeToUTC = exports.utcToLocalTime = exports.utcDayPeriodsToUtcDayMaskPeriod = exports.utcDayMaskPeriodToUtcDayPeriods = exports.sortUTCDayPeriods = exports.sortUTCPeriodHrMins = exports.isAscUTCPeriodHrsMinsArr = exports.isUTCPeriodsHrMinsArr = exports.isUTCDayMaskPeriod = exports.isUTCPeriodMins = exports.isDayMaskDefinition = exports.canonicalizeDayMask = exports.InsertBehavior = exports.getDayNumberFromDayMaskKey = exports.getDayMaskDayFromDayNumber = exports.dayMaskDays = exports.dayMaskAllTrueTemplate = exports.dayMaskTemplate = exports.UTC_MIN_RANGE = exports.UTC_HOUR_RANGE = exports.MINS_WEEK = exports.MINS_DAY = exports.MINS_HR = void 0;
const Validation_1 = require("../../Validation");
const Objects_1 = require("../Objects");
/** number of minutes in day -- used for relative UTC period lengths */
exports.MINS_HR = 60;
/** number of minutes in hour  -- used for relative UTC period lengths */
exports.MINS_DAY = 24 * exports.MINS_HR;
/** number of minutes in 7 day period  -- used for relative UTC period lengths */
exports.MINS_WEEK = 7 * exports.MINS_DAY;
exports.UTC_HOUR_RANGE = { min: 0, max: 23 };
exports.UTC_MIN_RANGE = { min: 0, max: 59 };
/** an all-false dayMask */
exports.dayMaskTemplate = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
};
exports.dayMaskAllTrueTemplate = {
    sunday: true,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
};
/** garaunteed correct order days typed as keyof DayMaskDefinition */
exports.dayMaskDays = Object.keys(exports.dayMaskTemplate);
const getDayMaskDayFromDayNumber = (n) => exports.dayMaskDays.at(n % 7);
exports.getDayMaskDayFromDayNumber = getDayMaskDayFromDayNumber;
const getDayNumberFromDayMaskKey = (key) => exports.dayMaskDays.findIndex((entry) => entry === key);
exports.getDayNumberFromDayMaskKey = getDayNumberFromDayMaskKey;
/** enum moved from EntityScheduler types on transfer to @iotv/lfc-devices */
var InsertBehavior;
(function (InsertBehavior) {
    /** shorten the inserted timeslot if overlaps with next */
    InsertBehavior["TRUNCATE"] = "TRUNCATE";
    /** shift following timeslots if next overlaps */
    InsertBehavior["SHIFT"] = "SHIFT";
})(InsertBehavior || (exports.InsertBehavior = InsertBehavior = {}));
/** potentially where order is important, eg perhaps getObjectHash with arrays containing dayMasks, ensure keys are in canonical order */
const canonicalizeDayMask = (dayMask) => Object.fromEntries(Object.keys(exports.dayMaskTemplate).map((k) => [k, dayMask[k]]));
exports.canonicalizeDayMask = canonicalizeDayMask;
const isDayMaskDefinition = (x) => {
    const c = x;
    return !!c && exports.dayMaskDays.every((d) => c[d] === true || c[d] === false);
};
exports.isDayMaskDefinition = isDayMaskDefinition;
const isUTCPeriodMins = (x) => {
    const c = x ?? {};
    const { duration_mins, utc_start_hour, utc_start_min } = c;
    return ([duration_mins, utc_start_hour, utc_start_min].every(Validation_1.isNonNaNNumber) &&
        (0, Validation_1.validAttributeNumberValue)(utc_start_hour, exports.UTC_HOUR_RANGE).isValid &&
        (0, Validation_1.validAttributeNumberValue)(utc_start_min, exports.UTC_MIN_RANGE).isValid);
};
exports.isUTCPeriodMins = isUTCPeriodMins;
const isUTCDayMaskPeriod = (x) => {
    const c = x ?? {};
    return (0, exports.isUTCPeriodMins)(c) && (0, exports.isDayMaskDefinition)(c.dayMask);
};
exports.isUTCDayMaskPeriod = isUTCDayMaskPeriod;
/** return true if all elements are UTCPeriodHrMins */
const isUTCPeriodsHrMinsArr = (x) => {
    let isValid = false;
    if (x instanceof Array) {
        const c = x;
        isValid = c.every(exports.isUTCPeriodMins);
    }
    return isValid;
};
exports.isUTCPeriodsHrMinsArr = isUTCPeriodsHrMinsArr;
/** return true if all elements are UTCPeriodHrMins and are in asc order */
const isAscUTCPeriodHrsMinsArr = (x) => {
    return ((0, exports.isUTCPeriodsHrMinsArr)(x) &&
        x.reduce((a, next, i, arr) => {
            if (i > 0) {
                const last = arr[i - 1];
                const lastTo = last.utc_start_hour * exports.MINS_HR + last.utc_start_min + last.duration_mins;
                const nextFrom = next.utc_start_hour * exports.MINS_HR + next.utc_start_min;
                a = a && lastTo <= nextFrom;
            }
            return a;
        }, true));
};
exports.isAscUTCPeriodHrsMinsArr = isAscUTCPeriodHrsMinsArr;
/** stor UTCPeriodHrMins by start time */
const sortUTCPeriodHrMins = (x1, x2) => {
    const x1DayMins = x1.utc_start_hour * exports.MINS_HR + x1.utc_start_min;
    const x2DayMins = x2.utc_start_hour * exports.MINS_HR + x2.utc_start_min;
    return x1DayMins < x2DayMins ? -1 : 1;
};
exports.sortUTCPeriodHrMins = sortUTCPeriodHrMins;
/** sort UTCDayPeriod by day and if same day by start time */
const sortUTCDayPeriods = (x1, x2) => {
    if (x1.utcDay !== x2.utcDay) {
        return x1.utcDay < x2.utcDay ? -1 : 1;
    }
    else {
        return (0, exports.sortUTCPeriodHrMins)(x1.p, x2.p);
    }
};
exports.sortUTCDayPeriods = sortUTCDayPeriods;
const utcDayMaskPeriodToUtcDayPeriods = (utcDayMaskPeriod) => {
    const { dayMask, ...uTCPeriodHrMins } = utcDayMaskPeriod;
    return Object.entries(dayMask)
        .filter(([dayKey, isOn]) => !!isOn)
        .map(([dayKey, isOn]) => {
        const utcDayPeriod = {
            p: uTCPeriodHrMins,
            utcDay: (0, exports.getDayNumberFromDayMaskKey)(dayKey),
        };
        return utcDayPeriod;
    });
};
exports.utcDayMaskPeriodToUtcDayPeriods = utcDayMaskPeriodToUtcDayPeriods;
/** convert utcDayPeriods of equal start time but differing days to utcDayMaskPeriod, eg where time has been shifted and days may not equal original utcDayMaskPeriod days
 * @throws Error when utcDayPeriods is empty or utcDayPeriods don't have matching
 */
const utcDayPeriodsToUtcDayMaskPeriod = (utcDayPeriods) => {
    if (utcDayPeriods.length > 0) {
        const clonedDayPeriods = [...utcDayPeriods];
        clonedDayPeriods.sort(exports.sortUTCDayPeriods);
        const initialUTCPeriodHrMins = clonedDayPeriods.at(0).p;
        if (clonedDayPeriods.every((c) => (0, Objects_1.objectsMatch)(c.p, initialUTCPeriodHrMins))) {
            const { duration_mins, utc_start_hour, utc_start_min } = initialUTCPeriodHrMins;
            const utcDayMaskPeriod = { dayMask: exports.dayMaskTemplate, duration_mins, utc_start_hour, utc_start_min };
            for (let period of clonedDayPeriods) {
                const dayMaskKey = (0, exports.getDayMaskDayFromDayNumber)(period.utcDay);
                utcDayMaskPeriod.dayMask[dayMaskKey] = true;
            }
            return utcDayMaskPeriod;
        }
        else {
            throw new Error(`utcDayPeriodsToUtcDayMaskPeriod must be provided utcDayPerids where each utcPeriodHrdMins are equal`);
        }
    }
    else {
        throw new Error(`utcDayPeriodsToUtcDayMaskPeriod nust be provided one or more UTCDayPeriods`);
    }
};
exports.utcDayPeriodsToUtcDayMaskPeriod = utcDayPeriodsToUtcDayMaskPeriod;
const utcToLocalTime = (utcHour, utcMin, utcMinsOffset) => {
    const utcMinsFromDayStart = (24 + utcHour) * exports.MINS_HR + utcMin;
    const local = utcMinsFromDayStart + utcMinsOffset;
    const localHr = (Math.floor(local / exports.MINS_HR) % 24);
    const localMin = (local % exports.MINS_HR);
    return { localHr, localMin };
};
exports.utcToLocalTime = utcToLocalTime;
const localTimeToUTC = (localHr, localMin, utcMinsOffset) => {
    const utcMinsFromDayStart = (24 + localHr) * exports.MINS_HR + localMin;
    const local = utcMinsFromDayStart - utcMinsOffset;
    const utcHour = (Math.floor(local / exports.MINS_HR) % 24);
    const utcMin = (local % exports.MINS_HR);
    return { utcHour, utcMin };
};
exports.localTimeToUTC = localTimeToUTC;
